import React from "react";
import GraficoAgrupado from "./GraficoAgrupado";

export default function GraficoMes(props) {
    return <GraficoAgrupado {...props} abaAtiva="mes" />;
}
